import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { FormArray, FormGroup, FormBuilder, FormsModule, FormControl, ReactiveFormsModule } from '@angular/forms';
import { projectConfig } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromtUserService {

  public apiURL: string = projectConfig.apiURL;
  // prompt_id : number = 0
  // user_id : number = 0
  private _prompt_id: number = 0;
  private _user_id: number = 0;

  attachmentForm: FormGroup;
  attachmentTabs = signal<{attachmentForm: FormGroup}[]>([]);
  RhsPanelStatus = signal<boolean>(false);
  stepperPosition = signal<number>(0);

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.attachmentForm = this.fb.group({
      otherAttachment: [null],
    });
  }

  private dataSource = new BehaviorSubject<any>({});
  currentData = this.dataSource.asObservable();

  changeData(data: any) {
    this.dataSource.next(data);
  }

  getPromptUser(promId  : number, userId : number) {
    const url = this.apiURL + 'prompt_manager/get_prompt_details?prompt_id=' +promId +'&user_id='+ userId ;
    return this.http.get<any>(url);
  }

  getAllPrompts(search_text : string , user_id : number, model_id : [] , category_id : [] , sub_category_id : [] , created_by : [] , my_favourites : boolean , my_prompts : boolean , approval_pending: boolean ,user_role : string ,status : [], sort_by : string,page_number:number,limit:number) {
    const bodyRequest = JSON.stringify({
      "search_text": search_text,
      "user_id": user_id,
      "my_favourites": my_favourites,
      "my_prompts": my_prompts,
      "approval_pending": approval_pending,
      "model": model_id,
      "created_by": created_by,
      "category":category_id,
      "sub_category": sub_category_id,
       "user_role": user_role,
       "sort_by": sort_by,
       "status": status,
       page_number,
       limit
    });
    return this.http.post<any>(`${this.apiURL}prompt_manager/get_all_prompts`, bodyRequest, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  addToFavouite(request:any) {
    const url = this.apiURL + 'prompt_manager/add_or_remove_prompt_to_from_favourites';
    return this.http.put<any>(url,request);
  }

  getAllCate(search_text : string , user_id : number, model_id : [] , category_id : [] , sub_category_id : [] , created_by : [] , my_favourites : boolean , my_prompts : boolean,user_role : string , status:[]) {
    const bodyRequest = JSON.stringify({
      "search_text": search_text,
      "user_id": user_id,
      "my_favourites": my_favourites,
      "my_prompts": my_prompts,
      "model": model_id,
      "created_by": created_by,
      "category":category_id,
      "sub_category": sub_category_id,
       "user_role": user_role,
       "status" : status
    });
    return this.http.post<any>(`${this.apiURL}prompt_master_data/categories`, bodyRequest, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  shareAttachment(attachment: {attachmentForm: FormGroup}[]) {
    this.attachmentTabs.set(attachment);
  }

  isRHSOpen(status: boolean) {
    this.RhsPanelStatus.set(status);
  }

  setStepperIndex(position: number) {
    this.stepperPosition.set(position);
  }

  set prompt_id(value: number) {
    this._prompt_id = value;
    localStorage.setItem('prompt_id', value.toString());
  }

  get prompt_id(): number {
    return parseInt(localStorage.getItem('prompt_id') || '0');
  }

  set user_id(value: number) {
    this._user_id = value;
    localStorage.setItem('user_id', value.toString());
  }

  get user_id(): number {
    return parseInt(localStorage.getItem('user_id') || '0');
  }
}